import { FC, useState } from 'react';
import { ReactComponent as HamburgerIcon } from 'atoms/icons/svg/hamburger.svg';
import { Popover, Stack } from '@mui/material';
import SidebarMenu from 'components/SidebarMenu';
import ButtonV2 from 'atoms/components/Buttons/V2/ButtonV2';
import SidebarBottomMenu from 'components/SidebarMenu/BottomMenu';
import './MobileMenu.scss';

const MobileMenu: FC = (): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'mobile-sidemenu' : undefined;

  return (
    <div className="mobile-sidemenu-icon">
      <ButtonV2
        size="m"
        type="secondary"
        icon={<HamburgerIcon />}
        onClick={handleOpen}
        iconOnly={true}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left', // safer on mobile
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            mt: '4px',
            width: { xs: '250px' },
          },
        }}
        className="mobile-menu"
      >
        <SidebarMenu isExpanded={true} />
        <div className="divider" />
        <Stack
          className="logout-action"
          direction="row"
          alignItems={'center'}
          spacing={1}
        >
          <SidebarBottomMenu isExpanded={true} />
        </Stack>
      </Popover>
    </div>
  );
};

export default MobileMenu;
